import { render, staticRenderFns } from "./InvoiceHistoryPage.vue?vue&type=template&id=9f81a144&scoped=true"
import script from "./InvoiceHistoryPage.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistoryPage.vue?vue&type=style&index=0&id=9f81a144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f81a144",
  null
  
)

export default component.exports